import { WarehouseService } from './../../acumatica/EntityServices/Warehouse.service';
import { LogService } from './../../services/logging.service';
import { SelectorEvent } from './../../common/inventory-id-selector/inventory-id-selector.component';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ShipmentService } from '../../acumatica/EntityServices/Shipment.service';
import { InventorySummaryInquiryService } from './../../acumatica/EntityServices/InventorySummaryInquiry.service';
import { MatDialog } from '@angular/material/dialog';
import { AudioService, Sound } from 'src/app/services/audio.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MayerFabricsService } from './../../services/mayer-fabrics.service';
import { SalesOrder, SalesOrderDetail, SalesOrderService } from './../../acumatica/EntityServices/SalesOrder.service';
import { ApplicationScreen } from 'src/app/application-navigator/application-screen';
import { Component, ElementRef, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { Customer, CustomerLocation, CustomerLocationService } from 'src/app/acumatica/EntityServices/Customer.service';
import { InventoryIDSelectorComponent } from 'src/app/common/inventory-id-selector/inventory-id-selector.component';
import { ItemType, StockItem, StockItemService } from 'src/app/acumatica/EntityServices/StockItem.service';
import { CatalogItemViewMode, CatalogTreeSortMethod, ICatalogTreeNode, ISalesRepCatalog, SalesRepCatalogItem, SalesRepCatalogService } from 'src/app/acumatica/EntityServices/SalesRepCatalog.service';
import { AlertDialog } from 'src/app/common/alert-dialog/alert-dialog.component';
import { forkJoin, noop, Observable } from 'rxjs';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { AcumaticaLoadingDialogComponent } from 'src/app/acumatica/loading-indicator/loading-dialog-indicator.component';
import { Address, DocContact } from 'src/app/acumatica/EntityServices/Contacts.service';
import { AcumaticaService } from 'src/app/acumatica/acumatica.service';
import { RepOrderShipToEnum } from 'src/app/common/general-components';
import { LoadingIndicator } from 'src/app/acumatica/loading-indicator/AcumaticaLoadingOptions';
import { RepOrderItemComponent } from './rep-order-item/order-item.component';
import { MatSelectChange } from '@angular/material/select';
import { StockItemSearchResult } from 'src/app/acumatica/EntityServices/StockItemSearch.service';
import { KitAuditService } from 'src/app/acumatica/EntityServices/KitAudit.service';
import { KitAuditItem } from '../kit-audit/kit-audit';
import { TitleCasePipe } from '@angular/common';

interface ICartEntry {
  item: SalesRepCatalogItem,
  qty: number,
  warehouseID: string
}

@Component({
  selector: 'app-rep-order-entry',
  templateUrl: './rep-order-entry.component.html',
  styleUrls: ['./rep-order-entry.component.css']
})
export class RepOrderEntryComponent extends ApplicationScreen {
  pageTitle = new FormControl();
  repWarehouse: string | null = null;
  // get isDirty(): boolean { return this.cartCount > 0; }

  screenMenuItems = [
    {
      label: 'Reload Item Catalog', icon: 'refresh', handler: () => {
        this.getItemCatalog(true);
      }
    },
    {
      label: 'Empty Cart',
      icon: 'shopping_cart_off',
      iconOutlined: true,
      condition: () => Object.keys(this.cart).length > 0,
      handler: () => { this.cart = []; this.SaveCart(); }
    },
    {
      break: true,
      label: 'Sort by SKU',
      icon: '123',
      condition: () => this.ItemSortMethod != CatalogTreeSortMethod.sku,
      handler: () => this.ItemSortMethod = CatalogTreeSortMethod.sku
    },
    {
      label: 'Sort by Name',
      icon: 'sort_by_alpha',
      condition: () => this.ItemSortMethod != CatalogTreeSortMethod.alphabetical,
      handler: () => this.ItemSortMethod = CatalogTreeSortMethod.alphabetical
    },
    {
      label: 'Group by Color',
      icon: 'palette',
      condition: () => this.ItemSortMethod != CatalogTreeSortMethod.color,
      handler: () => this.ItemSortMethod = CatalogTreeSortMethod.color
    },
    // {
    //   label: 'View as Grid',
    //   icon: 'grid_view',
    //   condition: () => this.ItemViewMode == CatalogItemViewMode.list,
    //   handler: () => this.ItemViewMode = CatalogItemViewMode.grid
    // },
    // {
    //   label: 'View as List',
    //   icon: 'list',
    //   condition: () => this.ItemViewMode == CatalogItemViewMode.grid,
    //   handler: () => this.ItemViewMode = CatalogItemViewMode.list
    // }
    {
      label: 'DEV',
      icon: 'adb',
      condition: this.isDevMode,
      handler: () => {
        this.kitAudit.UpdateCustomerSampleBooks(this.customer!.CustomerID!);
      }
    }
  ]

  constructor(
    public acumatica: AcumaticaService,
    private mayerfabrics: MayerFabricsService,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private audio: AudioService,
    private salesRepCatalog: SalesRepCatalogService,
    private salesorders: SalesOrderService,
    private shipments: ShipmentService,
    private inventory: InventorySummaryInquiryService,
    private stockItems: StockItemService,
    private warehouses: WarehouseService,
    private customerLocations: CustomerLocationService,
    private logger: LogService,
    private kitAudit: KitAuditService,
  ) {
    super();

    if (this.mayerfabrics.RepWarehouseID == null) { this.router.navigate(['/']); return; }
    if (this.mayerfabrics.RepCustomerID == null) { this.router.navigate(['/']); return; }

    // initialize SO settings
    this.order = new SalesOrder({
      Details: [],
      MarketplaceID: 'REP-APP',
      OrderedbyRep: this.acumatica.username,
      ShipVia: 'FEDEX GROUND',
      ShipToContact: new DocContact()
    });

    // get the shipment number from the navigation router
    this.route.paramMap.subscribe(params => {
      this.orderType = params.get('orderType');

      // a redirect from a Kit Audit
      if(this.orderType == 'audit') {
        this.fromKitAudit = true;
        this.orderType = 'SO';
        this.order.Description = 'Kit Audit Order';
      }
      
      if (this.orderType != 'SO' && this.orderType != 'TR') this.router.navigate(['/']);

      this.order.OrderType = this.orderType!;
      if (this.orderType == 'TR') {

        // verify Rep Warehouse and Rep Customer ID are set
        if (this.acumatica.RepWarehouseID === null || this.acumatica.RepCustomerID === null) {
          this.dialog.open(AlertDialog, {
            data: {
              message: "Your Sales Rep Warehouse and/or Customer ID have not been configured. Contact I.T.",
              buttonText: 'OK',
              icon: 'error'
            }
          }).afterClosed().subscribe(() => {
            this.router.navigate(['/']);
          });
        }

      }

      this.repWarehouse = this.acumatica.RepWarehouseID;
      if (this.orderType == 'TR') this.order.DestinationWarehouseID = this.repWarehouse;
      this.pageTitle.setValue(this.orderType == 'SO' ? 'Customer Order' : 'Order Supplies');

      this.getItemCatalog().then(() => {
        this.LoadCart();
        
        if(this.fromKitAudit) this.AddKitAuditComponentsToOrder();
      });
    
    });
  }

  // #region UI template exposures
  @ViewChild('itemSelector', { static: true }) itemSelector!: InventoryIDSelectorComponent;
  @ViewChildren('repOrderItem') repOrderItems!: QueryList<RepOrderItemComponent>;

  LifeCycleColor = this.mayerfabrics.LifeCycleColor;
  LifeCycleContrastColor = this.mayerfabrics.LifeCycleContrastColor;
  RepOrderShipToEnum = RepOrderShipToEnum;
  shipTo: RepOrderShipToEnum = RepOrderShipToEnum.Customer;
  AllowWillCall = ['janeyz'].contains(this.acumatica.username?.toString().toLowerCase());

  onTabChanged(event: MatTabChangeEvent) {
    if (event.tab.textLabel == "Items") {
      this.itemSelector.reset();
    }
  }
  // #endregion

  // #region Screen Options / Settings

  RepOrderMemoSortMethodKey = 'rep-order-memo-sort-method';
  get ItemSortMethod(): CatalogTreeSortMethod {
    let val = localStorage.getItem(this.RepOrderMemoSortMethodKey);
    return val === null ? CatalogTreeSortMethod.alphabetical : parseInt(val);
  }
  set ItemSortMethod(value: CatalogTreeSortMethod) {
    if (value === this.ItemSortMethod) return;
    localStorage.setItem(this.RepOrderMemoSortMethodKey, value.toString());
    if (this.catalog) this.catalogDataSource.data = this.salesRepCatalog.catalogToTree(this.catalog, value);
  }

  RepOrderViewModeKey = 'rep-order-view-mode';
  private _ItemViewMode?: CatalogItemViewMode;
  get ItemViewMode(): CatalogItemViewMode {
    // use memory cached value to reduce localStorage calls
    if (this._ItemViewMode === undefined) {
      let val = localStorage.getItem(this.RepOrderViewModeKey);
      this._ItemViewMode = val === null ? CatalogItemViewMode.list : parseInt(val);
    }
    return this._ItemViewMode;
  }
  set ItemViewMode(value: CatalogItemViewMode) {
    if (value === this.ItemViewMode) return;
    localStorage.setItem(this.RepOrderViewModeKey, value.toString());
    this._ItemViewMode = value;

    // TODO: switch layouts
  }
  get displayAsList(): boolean { return this.ItemViewMode == CatalogItemViewMode.list; }

  // #endregion

  // #region Items / Inventory

  // inventory data of items placed in cart for Mayer and Sales Rep warehouse
  itemInventory: { [key: string]: ItemInventoryAvailable | null } = {};
  stockItem: { [key: string]: StockItem | null } = {};

  // keep a counter of in-process inventory checks
  // disable checkout while getting inventories
  gettingInventories: number = 0;
  getItemInventory(inventoryID: string) {
    // let snackBarRef = this.snackBar.open("Checking inventory for " + inventoryID);
    let getMayerWhse = this.inventory.getWhseQtyAvailable(inventoryID, '03');
    let getRepWhse = this.inventory.getWhseQtyAvailable(inventoryID, this.repWarehouse!);
    this.gettingInventories++;
    this.itemInventory[inventoryID] = null; // indicates already fethching in case of rapid (+) clicking
    forkJoin([getMayerWhse, getRepWhse]).subscribe(qty => {
      this.itemInventory[inventoryID] = {
        Mayer: qty[0],
        SalesRep: qty[1]
      }
      this.gettingInventories--;
      // snackBarRef.dismiss();
    });
  }

  gettingStockItems: number = 0;
  getStockItem(inventoryID: string) {
    this.gettingStockItems++;
    this.stockItem[inventoryID] = null;
    this.stockItems.get(inventoryID, { loader: null }, false).subscribe(item => {
      this.stockItem[inventoryID] = item;
      this.gettingStockItems--;
    });
  }

  /** takes an array of SearchResults and filters them to the ones contained in the rep catalog */
  searchValidator(searchResults: StockItemSearchResult[]): StockItemSearchResult[] {
    let validIDs = (<any>this.searchValidator).validIDs;
    return searchResults.filter(result => validIDs.contains(result.InventoryID.toUpperCase()));
  }

  // #endregion

  // #region Shopping Cart

  // 'shopping cart' of items to be added to Sales Order Details
  cart: ICartEntry[] = [];
  get cartCount() { return Object.keys(this.cart).length; }

  // #region Persistance to storage
  
  private localCartStorageKey = 'rep-order-cart';
  private _isLoadingCart = false;
  
  SaveCart() {
    if(this._isLoadingCart) return;

    let serial: any = {};
    this.cart.forEach(line => {
      serial[line.warehouseID] ||= {}
      serial[line.warehouseID][line.item.InventoryID] = line.qty;
    });
    localStorage.setItem(this.localCartStorageKey, JSON.stringify(serial));
  }
  LoadCart() {
    let serial = localStorage.getItem(this.localCartStorageKey);
    if(serial == null) return;

    this._isLoadingCart = true;
    this.cart = [];
    let data = JSON.parse(serial);
    Object.keys(data).forEach(warehouseID => {
      Object.keys(data[warehouseID]).forEach(inventoryID => {
        this.addToCart(inventoryID, data[warehouseID][inventoryID], warehouseID, false);
      })
    });
    this._isLoadingCart = false;
  }
  ClearCart() {
    localStorage.removeItem(this.localCartStorageKey);
  }

  // #endregion

  addToCartFromSearch(item: StockItem | undefined) {
    let invalidItem = () => {
      this.audio.play(Sound.ErrorBeep);
      this.snackBar.open('Invalid Inventory ID / Item not available', undefined, { duration: 5000 });
      this.itemSelector.focus();
    };

    if (item === undefined) { invalidItem(); return; }
    let catalogItem = this.getCatalogItem(item);
    if (catalogItem === undefined) { invalidItem(); return; }

    let qty = (this.cartItem(item.InventoryID)?.qty || 0) + 1;
    this.addToCart(catalogItem!, qty);
    this.snackBar.open(item.InventoryID + ' - ' + item.Description + ' ordered (' + qty.toString() + ')', undefined, { duration: 5000 });
    this.itemSelector.reset();
  }

  /** return the item from the cart for the given inventoryID. Returns undefined if not present */
  cartItem(inventoryID: string): ICartEntry | undefined { return this.cart.find(entry => entry.item.InventoryID == inventoryID); }

  updateCartQuantity(node: FlatTreeNode | string, qty: number | null) {
    let id: string = typeof node == 'string' ? node : node.inventoryID;

    if (qty) this.addToCart(id, qty);
    else this.removeFromCart(id);
  }

  // add given item to the cart and fetch the inventory
  addToCart(item: string | SalesRepCatalogItem | KitAuditItem, qty: number, warehouseID: string = '03', refreshUICart: boolean = true): SalesRepCatalogItem | undefined {
    let inventoryID: string;
    let catalogItem: SalesRepCatalogItem | undefined;
    if (item instanceof SalesRepCatalogItem) {
      inventoryID = item.InventoryID;
      catalogItem = item;
    } else if(item instanceof KitAuditItem) {
      inventoryID = item.InventoryID;
      catalogItem = this.getCatalogItem(inventoryID);

      // Kit Audit could specify items not in the catalog
      if(catalogItem === undefined) return undefined;
    } else {
      inventoryID = item;
      catalogItem = this.getCatalogItem(item)!;
    }

    // check sales rep and mayer warehouse inventories
    if (this.itemInventory[inventoryID] === undefined) {
      this.getItemInventory(inventoryID);
    }
    if (this.stockItem[inventoryID] === undefined) {
      this.getStockItem(inventoryID);
    }   

    this.removeFromCart(inventoryID);
    this.cart.push({
      item: catalogItem,
      qty: qty,
      warehouseID: warehouseID
    });

    if(refreshUICart) this.refreshCart();

    return catalogItem;
  }

  /** removes the item from the cart for the given inventoryID */
  removeFromCart(inventoryID: string) {
    let entry = this.cartItem(inventoryID);
    this.cart.remove(entry);
    this.refreshCart();
  }

  addItemSetToCart(itemset: string[]) {
    itemset.forEach(item => this.addToCart(item, 1));
    this.refreshCart();
  }

  refreshCart() {
    // Refresh of the Review table in the template by making the cart object appear as a 'new' object to Angular
    // this.cart = { ...this.cart };
    
    // build a new, sorted Cart object which will trigger a refresh of the Cart table in UI
    this.cart = this.cart.sort((a, b) => {
      // sort/group by Item Class
      if(a.item.ClassID != b.item.ClassID) return a.item.ClassID.localeCompare(b.item.ClassID);
      // then sort by Inventory ID
      return a.item.InventoryID.localeCompare(b.item.InventoryID);
    })
    
    // Persist the cart to local storage
    this.SaveCart();
  }

  // #endregion

  // #region Customer

  customer?: Customer;
  _customerLocation?: CustomerLocation;
  get customerLocation(): CustomerLocation | undefined { return this._customerLocation; }
  set customerLocation(value: CustomerLocation | undefined) {
    this._customerLocation = value;
    this.setCustomerLocation(value?.LocationID);
  }
  customerActiveLocations(): CustomerLocation[] {
    if (!this.customer?.Locations) return [];
    return this.customer.Locations?.filter(loc => loc.Active);
  }

  // #endregion

  // #region Order

  order!: SalesOrder;
  orderType!: string | null;
  /** a flag indicating if the user was navigated here as a result of a Kit Audit > [Order Missing Items] */
  fromKitAudit: boolean = false;

  get isSO() { return this.orderType == 'SO'; }
  get isTR() { return this.orderType == 'TR'; }
  projectName: string | null = null;
  projectLocation: string | null = null;

  shipViaOptions: ShipViaOption[] = [
    { ID: "WILL CALL", Description: "Will Call", condition: this.AllowWillCall },

    { ID: "FEDEX GROUND", Description: "FedEx Ground", ShipNbrLen: 9 },
    { ID: "FEDEX PRIORITY", Description: "FedEx Priority", ShipNbrLen: 9 },
    { ID: "FEDEX STD OVERN", Description: "FedEx Std. Overnight", ShipNbrLen: 9 },
    { ID: "FEDEX 2 DAY", Description: "FedEx 2 Day", ShipNbrLen: 9 },
    { ID: "FEDEX INTL GROU", Description: "FedEx Intl. Ground", ShipNbrLen: 9 },
    { ID: "FEDEX INTL PRIO", Description: "FedEx Intl. Priority", ShipNbrLen: 9 },

    { ID: "UPS GROUND", Description: "UPS Ground", ShipNbrReq: true, ShipNbrLen: 6 },
    { ID: "U P S  NEXT DAY", Description: "UPS Next Day", ShipNbrReq: true, ShipNbrLen: 6 },
    { ID: "U P S  2ND AM", Description: "UPS 2nd Day AM", ShipNbrReq: true, ShipNbrLen: 6 },
    { ID: "U P S  2ND DAY", Description: "UPS 2nd Day", ShipNbrReq: true, ShipNbrLen: 6 },
    { ID: "U P S  3 DAY", Description: "UPS 3 Day", ShipNbrReq: true, ShipNbrLen: 6 },
    { ID: "U P S  INTL STD", Description: "UPS Intl. Std.", ShipNbrReq: true, ShipNbrLen: 6 },
    { ID: "U P S  INTL EXP", Description: "UPS Intl. Exp.", ShipNbrReq: true, ShipNbrLen: 6 },

  ]
  get shipVias() { return this.shipViaOptions.filter(shipVia => shipVia.condition !== false) }

  onCustomerChanged(customer: Customer | null) {
    this.customer = customer || undefined;
    this.customerLocation = customer?.Locations?.find(loc => loc.Default);
  }

  setCustomerLocation(LocationID: string | undefined) {
    if (LocationID == undefined) {
      this.order.ShipToAddress = undefined;
      this.order.ShipToContact = undefined;
      return;
    }

    if (!this.customer == undefined) return;

    // need to get Customer Location using CustomerLocation service to retrieve the full CustomerLocation object,
    // rather than just the row contained in the Customer > Locations grid
    this.customerLocations.get(this.customer!.CustomerID!, LocationID, {
      loader: {
        indicator: LoadingIndicator.snackbar,
        message: 'Getting Location Details'
      }
    }).subscribe(result => {
      const location = result;

      this.order.ShipToContact = location.GetOrderContact();

      this.order.ShipToAddress = location.GetOrderAddress();
    });
  }

  @ViewChild('CustomerShipperNbrField') CustomerShipperNbrField!: ElementRef;
  shipVia: ShipViaOption = this.shipViaOptions[1];
  updateShipVia(value: MatSelectChange) {
    this.shipVia = this.shipViaOptions.find(opt => opt.ID == value.value)!;
    this.order.ShipVia = this.shipVia.ID;
  }

  placeOrder() {
    if (this.shipVia.ShipNbrReq && !this.order.ShipperUPSFedExNbr) {
      this.dialog.open(AlertDialog, { data: { message: "A valid Customer Shipper Number is required to ship via " + this.shipVia.Description } });
      return;
    }
    if (this.shipVia.ShipNbrLen && this.order.ShipperUPSFedExNbr && this.order.ShipperUPSFedExNbr.length != this.shipVia.ShipNbrLen) {
      this.dialog.open(AlertDialog, { data: { message: "The provided Shipper Number does not appear to be valid for the selected ship via" } });
      return;
    }

    let repMemoOrder: SalesOrder | null = null;

    // shipping to sales rep requires async fetch for address; promise resolves when ready to continue processing
    let getShippingAddressReady = (): Promise<void> => new Promise<void>((resolve, reject) => {

      if (this.isSO) {
        if (!this.customer) {
          this.dialog.open(AlertDialog, { data: { message: "A Customer must be specified" } });
          reject(); return;
        }
        if (!this.customerLocation) {
          this.dialog.open(AlertDialog, { data: { message: "A Customer Location must be selected" } });
          reject(); return;
        }

        this.order.CustomerID = this.customer!.CustomerID!;
        this.order.LocationID = this.customerLocation!.LocationID!;

        // shipping to customer
        if (this.shipTo == RepOrderShipToEnum.Customer) {
          if (this.order.ShipToContactOverride) {
            this.order.OrderedBy = this.order.ShipToContact!.Attention;
            this.order.EmailAddress = this.order.ShipToContact!.Email;
            this.order.Phone = this.order.ShipToContact!.Phone1;
          }
          resolve(); return;
        }
        // shipping to sales rep
        else {
          this.warehouses.get(this.mayerfabrics.RepWarehouseID!, { loader: "Getting Ship-To Address" }).subscribe(warehouse => {
            this.order.ShipToContactOverride = true;
            this.order.ShipToContact = new DocContact({
              BusinessName: warehouse.AccountName,
              Attention: warehouse.Attention,
              Phone1: warehouse.Phone1,
              Email: warehouse.Email?.toLowerCase()
            });

            this.order.ShipToAddressOverride = true;
            this.order.ShipToAddress = new Address({
              AddressLine1: warehouse.AddressLine1,
              AddressLine2: warehouse.AddressLine2,
              City: warehouse.City,
              State: warehouse.State,
              PostalCode: warehouse.PostalCode,
              Country: warehouse.Country,
            });

            this.order.OrderedBy = warehouse.Attention || warehouse.AccountName;
            this.order.EmailAddress = warehouse.Email?.toLowerCase();
            this.order.Phone = warehouse.Phone1;

            resolve(); return;
          });
        }
      } else if (this.isTR) {
        repMemoOrder = new SalesOrder(this.order);
        repMemoOrder.OrderType = 'SO';
        repMemoOrder.CustomerID = this.mayerfabrics.RepCustomerID;
        repMemoOrder.MarketplaceID = this.order.MarketplaceID;
        repMemoOrder.OrderedbyRep = this.order.OrderedbyRep;
        repMemoOrder.Details = [];
        resolve(); return;
      }
    });

    // update Customer Sample books first as repeated calls should have no effect
    let updateCustomerSampleBooks = (): Promise<void> => new Promise<void>((resolve, reject) => {
      if(!this.kitAudit.audit) return resolve();

      this.logger.log(this.acumatica.username, ['Kit Audit'], JSON.stringify(this.kitAudit.audit.serialize()));
      return this.kitAudit.UpdateCustomerSampleBooks(this.customer!.CustomerID!).then(resolve).catch(reject);
    })

    updateCustomerSampleBooks().then(() =>
    getShippingAddressReady().then(() => {
      this.order.Details = [];

      let anySalesRepWhseItems: boolean = false;

      this.cart.forEach(entry => {        
        let detail = new SalesOrderDetail();
        detail._fetchInventoryItem = false;
        detail.InventoryID = entry.item.InventoryID;
        detail.OrderQty = entry.qty;
        detail.WarehouseID = entry.warehouseID;
        detail.ProjectName = this.projectName;
        detail.ProjectLocation = this.projectLocation;

        // sales rep ordering Memos for their supply are going to standard Sales Order instead of 'Transfer'
        // -- they had a conniption when told they'd need to track their memos      
        switch (this.stockItem[entry.item.InventoryID]!.ItemType) {
          case ItemType.MemoSample:
          case ItemType.TagSet:
          case ItemType.CollatedSet:
            if (this.isTR) {
              repMemoOrder!.Details!.push(detail);
            } else {
              this.order.Details!.push(detail);
            }
            break;
          case ItemType.SampleCard:
          case ItemType.EmptyBinderShell:
          case ItemType.FullCardBinder:
            this.order.Details!.push(detail);
            anySalesRepWhseItems ||= (detail.WarehouseID == this.repWarehouse);
            break;

          default:
            this.order.Details = [];
            throw new Error("Item is not allowed for Ordering: " + entry.item.InventoryID);
        }
      });

      let self = this;
      let openConfirmationDialog = function (so: SalesOrder) {
        self.dialog.open(AlertDialog, {
          data: {
            message: (self.isTR ? "Transfer" : "Customer") + " Order " + so.OrderNbr + " Created",
            buttonText: 'OK'
          }
        }).afterClosed().subscribe(() => {
            self.cart = [];
            self.SaveCart();
            self.router.navigate(['/']);
        })
      }

      // Transfer order (to rep supply) for Memo Samples...
      if (this.isTR && repMemoOrder!.Details!.length > 0) {
        this.logger.log(this.acumatica.username, ['Rep TR Memo Order'], JSON.stringify(repMemoOrder));

        this.salesorders.put(repMemoOrder!, { loader: "Creating Sales Order..." }).subscribe(so => {
          self.dialog.open(AlertDialog, {
            data: {
              message: "Memo Order " + so.OrderNbr + " Created",
              buttonText: 'OK'
            }
          }).afterClosed().subscribe(() => {
            if (this.order.Details!.length == 0) {
              self.SaveCart();
              self.cart = [];
              self.router.navigate(['/']);
            }
          })
        });
      }

      // Transfer order for other items or Customer Order...
      if (this.order.Details!.length > 0) {
        this.logger.log(this.acumatica.username, ['Rep ' + this.order.OrderType + ' Order'], JSON.stringify(this.order));

        this.salesorders.put(this.order, { loader: "Creating Sales Order..." }).subscribe(so => {

            this.kitAudit.audit = undefined;

            if (anySalesRepWhseItems) {
              let dialogRef = this.dialog.open(AcumaticaLoadingDialogComponent);
  
              dialogRef.componentInstance.message = "Creating Shipment";
  
              this.shipments.createShipment(so.OrderType, so.OrderNbr, this.repWarehouse!, true)
                .subscribe(soshipment => {
                  this.shipments.get(soshipment.ShipmentNbr, { loader: null }).subscribe(shipment => {
                    dialogRef.componentInstance.message = "Updating Quantities";
                    shipment.DoNotAutoPrintPickList = true;
                    shipment.Details.forEach(detail => {
                      let alloc = detail.NewAllocation();
                      alloc.Qty = detail.OrderedQty;
  
                      if (detail.WarehouseID == this.acumatica.RepWarehouseID) alloc.LocationID = 'MAIN';
                    });
                    this.shipments.put(shipment, { loader: null }).subscribe(updatedShipment => {
                      dialogRef.componentInstance.message = "Confirming Shipment";
                      this.shipments.confirmShipment(updatedShipment, { loader: null }).subscribe(() => {
                        dialogRef.close();
                        openConfirmationDialog(so);
                      });
                    });
                  });
                });
            } else {
              openConfirmationDialog(so);
            }

        });
      }

    },

    /* shipping ready reject() */
    noop));
  }

  /**
   * return a string array of inventory IDs from the cart the sales rep has inventory for
   */
  cartItemsInSalesRepInventory(): string[] {
    return Object.keys(this.cart).filter(inventoryID => this.itemInSalesRepInventory(inventoryID));
  }

  /**
   * returns quantity in the sales rep has inventory for the given inventory ID
   */
  itemInSalesRepInventory(inventoryID: string): number {
    return this.itemInventory[inventoryID]?.SalesRep || 0;
  }

  toggleRepSupply(inventoryID: string, event: MatSlideToggleChange) {
    this.cartItem(inventoryID)!.warehouseID = event.checked ? this.repWarehouse! : '03';
  }

  fillAllFromRepInventory() {
    this.cartItemsInSalesRepInventory().forEach(inventoryID => {
      this.cartItem(inventoryID)!.warehouseID = this.repWarehouse!;
    });
  }
  // #endregion

  // #region User Interaction / Scanner Input
  barcodeValidation(event: SelectorEvent) {
    if (event?.value) this.processItemInput(event.value);
  }

  checkForQRScan(value: string) {
    this.snackBar.open(value, undefined, {
      duration: 3000
    });
    value = value.trim().toUpperCase();
    // if (value.startsWith("HTTP://") || value.startsWith("HTTPS://"))
    this.processItemInput(value);
  }

  processItemInput(value: string) {
    value = value.trim().toUpperCase();

    // parse out the last part of the URL path if a URL was scanned
    if (value.startsWith("HTTP://") || value.startsWith("HTTPS://")) {
      let url = new URL(value.toLowerCase());
      let path = url.pathname.split("/");
      value = path[path.length - 1].toUpperCase();
      this.itemSelector.inventoryID = null;
    }

    // try to find the item with the scanned value as given
    var item = this.getCatalogItem(value)
    if (item) {
      this.itemSelector.inventoryID = value;
      return;
    }

    // some memo sample tags went out without the 'M' prefix
    // if we don't have the scanned value, but we do have it with an 'M' prefixed, set that as the value
    if (this.getCatalogItem('M' + value) !== undefined) {
      this.itemSelector.inventoryID = 'M' + value;
      return;
    }

    // if a Class ID has parsed out of a URL
    if (this.classIDs.contains(value)) {
      // just open the group within the Memo Samples tree node
      this.expandMemoClassNode(value);

      // we're not going to select / add any specific items
      this.itemSelector.inventoryID = null;
      return;
    }

  }

  processScannedBarcode(item: StockItem | undefined) {
    if (item === undefined) return;

    // this.addToCartFromSearch(item);

    this.addMemoItemInTree(item);
  }

  /** expand the [Memo Samples] > {Item Class} node for the given item class */
  expandMemoClassNode(classID: string) {
    this.treeControl.collapseAll();

    // expand "Memo Samples"
    this.treeControl.expand(this.treeControl.dataNodes[0]);

    // expand the Item Class node
    let classNode = this.treeControl.dataNodes.find(node => node.key == 'CLASS/' + classID);
    if (classNode) this.treeControl.expand(classNode);
  }

  /** expand the [Memo Samples] > {Item Class} node for the given item and increment the order quantity */
  addMemoItemInTree(item: StockItem) {
    if (item.ItemClass?.ClassID == 'CD') {
      if (item.PatternClassID === undefined) {
        this.dialog.open(AlertDialog, { data: { message: "No Pattern Class specified for Card stock item" } });
        return;
      }
      this.expandMemoClassNode(item.PatternClassID);
    }
    else {
      this.expandMemoClassNode(item.PrimaryItem.ItemClassID);
    }

    // focus the Item Input
    setTimeout(() => {
      let component = this.repOrderItems.find(component => component.item.InventoryID == item.InventoryID);
      if (component) {
        component.qty = (component.qty || 0) + 1;
        component.onQtyChange.emit(component.qty);
        component.focus();
      }
    }, 100);
  }
  // #endregion

  // #region Catalog / Tree interface

  catalogItems!: SalesRepCatalogItem[];
  catalog: ISalesRepCatalog | null = null;
  treeCatalog?: ICatalogTreeNode[];
  classIDs!: string[];

  /** get the full catalog of inventory items from local cache or Acumatica */
  getItemCatalog(ignoreDeviceCache: boolean = false): Promise<void> {
    return new Promise<void>(resolve => {

      this.salesRepCatalog.getItems({ loader: "Refreshing Item Catalog" }, ignoreDeviceCache).subscribe(items => {
        this.catalogItems = items;
        (<any>this.searchValidator).validIDs = items.map(item => item.InventoryID.toUpperCase());

        // retain a list of unique Class IDs (used to identify if a URL gets scanned ending with a Class ID)
        this.classIDs = items.map(item => item.ClassID).unique<string>();

        this.salesRepCatalog.getCatalog(items).subscribe(catalog => {
          this.catalog = catalog;
          this.catalogDataSource.data = this.salesRepCatalog.catalogToTree(catalog, this.ItemSortMethod);

          resolve();
        });
      });

    });
  }

  /** get the SalesRepCatalogItem for the given inventory ID */
  getCatalogItem(item: string | StockItem): SalesRepCatalogItem | undefined {
    let inventoryID = (item instanceof StockItem) ? item.InventoryID : item;
    return this.catalogItems.find(item => item.InventoryID.toUpperCase() == inventoryID.toUpperCase());
  }

  // _transformer takes in the original object type
  // and returns a FlatTreeNode object used by the DOM including mandatory minimum fields level & expandable
  private _transformer = (node: ICatalogTreeNode, level: number): FlatTreeNode => {
    return {
      level: level,
      expandable: !!node.children && node.children.length > 0,
      key: node.key,
      description: node.description,
      inventoryID: node.inventoryID || '',
      item: node.ref instanceof SalesRepCatalogItem ? node.ref as SalesRepCatalogItem : null,
      itemset: node.itemset || null,
    };
  };

  treeControl = new FlatTreeControl<FlatTreeNode>(
    node => node.level,
    node => node.expandable,
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    node => node.level,
    node => node.expandable,
    node => node.children,
  );

  catalogDataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  hasChild = (_: number, node: FlatTreeNode) => node.expandable;
  isItemSet = (_: number, node: FlatTreeNode) => node.itemset !== null;

  toggleNode(node: FlatTreeNode) {
    if (!node.expandable) return;
    this.treeControl.toggle(node);
  }
  // #endregion

  // #region Kit Audit Integration

  public AddKitAuditComponentsToOrder() {
    var unavailableItems: string[] = [];

    // add any missing components from the checked kits to the order
    this.kitAudit.audit!.kits
    .filter(kit => kit.AnyChecked())
    .forEach(kit => {
      kit.Unchecked().forEach(item => {
        let catalogItem = this.addToCart(item, 1);
        let titlecasePipe = new TitleCasePipe();
        if(catalogItem === undefined) unavailableItems.push(`• ${titlecasePipe.transform(kit.Description)} - ${item.Description} (${item.InventoryID})`);
      });
    });

    // add any Empty Binder Shells that were flagged to the order
    if(this.kitAudit.audit!.anyBinderShellsPlaced) { // items could be selected but the main user flag then turned off
      Object.keys(this.kitAudit.audit!.placedEmptyShells)
      .filter(shellID => this.kitAudit.audit!.placedEmptyShells[shellID])
      .forEach(shellID => this.addToCart(shellID, 1))
    }

    if(unavailableItems.length > 0) {
      this.dialog.open(AlertDialog, {data:{
        icon: 'warning',
        message:"These audit items are unavailable for order:\n" + unavailableItems.join("\n"),
        buttonText:'OK'
      }});
    }
  }

  // #endregion
}

interface FlatTreeNode {
  level: number;
  expandable: boolean;
  key?: string;
  description: string;
  inventoryID: string;
  item: SalesRepCatalogItem | null;
  itemset: string[] | null;
}

interface ItemInventoryAvailable {
  Mayer?: number;
  SalesRep?: number;
}

interface ShipViaOption {
  ID: string;
  Description: string;
  ShipNbrReq?: boolean;
  ShipNbrLen?: number;
  condition?: boolean;
}